import axios from '../api/axios'
import { downloadFile } from '../utils'

export const downloadInvoice = (orderKey: string): Promise<void> =>
  axios
    .get<string>(`/orreca/v1/orders/${orderKey}/invoice`, {
      responseType: 'blob',
    })
    .then((response) => downloadFile(response.data, 'Invoice', 'application/pdf'))
